import { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { selectableSites, useSitesList } from '../../api/queries';

/**
 * Site selector shared by the cash-desk pages. Every cash-desk surface is
 * per-site (terminals, options, activities), so each page leads with this.
 * Auto-selects the only site when the operator has exactly one.
 */
export function SitePicker({ siteId, onChange }: {
  siteId: string | null;
  onChange: (siteId: string) => void;
}) {
  const { queryKey, listFn } = useSitesList();
  const sites = useQuery({ queryKey, queryFn: listFn });

  const options = selectableSites(sites.data);
  useEffect(() => {
    if (siteId === null && options.length === 1) onChange(options[0].id);
  }, [siteId, options, onChange]);

  return (
    <FormControl size="small" sx={{ minWidth: 280 }}>
      <InputLabel id="cashdesk-site-label">Site</InputLabel>
      <Select
        labelId="cashdesk-site-label"
        label="Site"
        value={siteId ?? ''}
        data-testid="cashdesk-site-picker"
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((s) => (
          <MenuItem key={s.id} value={s.id}>{s.displayName}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
